import type { AiContext } from './types/ai-context';

export function buildAiContext(params: {
  pr: AiContext['pr'];
  codeContent?: AiContext['codeContent'];
  files?: AiContext['files'];
  headSha?: string | null;
  baseSha?: string | null;
  orderedFiles?: AiContext['orderedFiles'];
  reviewDecisions?: AiContext['reviewDecisions'];
  activeFilename?: string | null;
  visibleFilename?: string | null;
}): AiContext {
  return {
    pr: params.pr,
    codeContent: params.codeContent ?? [],
    files: params.files ?? [],
    headSha: params.headSha ?? undefined,
    baseSha: params.baseSha ?? undefined,
    orderedFiles: params.orderedFiles ?? [],
    reviewDecisions: params.reviewDecisions ?? undefined,
    activeFilename: params.activeFilename ?? undefined,
    visibleFilename: params.visibleFilename ?? undefined,
  };
}
